import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { StackOutput } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";

type OutputWithStack = StackOutput & {
  stackId: string;
  stackName: string;
};

const TemplateDeploymentOutputsStackCell = ({
  item: output,
  ...cellProps
}: TableSimpleCellProps<OutputWithStack>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLink href={`/stack/${output.stackId}`}>{output.stackName}</TableCellLink>
    </TableSimpleCell>
  );
};

export default TemplateDeploymentOutputsStackCell;
